import { find } from "lodash";
import { useCurrentProject } from "@radarly/core/project/use-cases";

export function useGetWorkspaceById(id) {
  const project = useCurrentProject();
  if (!id) {
    return null;
  }
  return find(project.dashboards, { id });
}
